import { InsightTag } from '@ecosystem/newron-client-collections/build/shared/types';
import { getCountryCodes } from '@utils/CountryUtils';
import { getBaseTimePeriodForMATAndYTD, getPeriodicityForMATAndYTD } from '@utils/PeriodUtils';
import { capitalizeEachWord, capitalizeFirstLetter } from '@utils/StringUtils';
import {
  addAllProductGroupFilter,
  addCountryLoadedTagInPlace,
  addPgLoadedTagInPlace,
  getGeneralCollectionInsightTags,
  getIsUsingCollectionLiveData,
  getPeriodLabel,
} from '@utils/collectionUtils/CollectionUtils';
import { CategoryLeaderboardDoubleBarChartInsight } from './Model';

export const getDoubleBarChartInsightInfoTags = async (
  insight: CategoryLeaderboardDoubleBarChartInsight,
): Promise<InsightTag[]> => {
  const {
    apiParams: {
      appliedFilters,
      clientId,
      periodType,
      period,
      comparisonPeriod,
      countries,
      productType,
      showPerformance,
      productGroup,
    },
    selectedGrowthType,
    selectedKpiOption,
    collectionDataType,
    retailerClientName,
  } = insight;

  const baseTimePeriod = getBaseTimePeriodForMATAndYTD(period, periodType);
  const { periodicity } = getPeriodicityForMATAndYTD(baseTimePeriod, periodType);

  const periodLabel = await getPeriodLabel({
    clientId,
    periodicity,
    baseTimePeriod,
    comparisonPeriod,
    countryIds: getCountryCodes(countries),
    productType,
    collectionDataType: getIsUsingCollectionLiveData(period, collectionDataType) ? 'live' : collectionDataType,
    productGroups: productGroup,
  });

  const baseTags = getGeneralCollectionInsightTags({
    periodType: periodicity,
    comparisonPeriod:
      typeof comparisonPeriod === 'object' && comparisonPeriod !== null
        ? JSON.stringify(comparisonPeriod)
        : String(comparisonPeriod),
    selectedGrowthType: selectedGrowthType,
    appliedFilters: addAllProductGroupFilter(appliedFilters),
    period: periodLabel,
    retailerClientName: retailerClientName,
  });

  if (countries.length > 1) {
    const baseApiParams = {
      clientId,
      countries,
      productType,
      period,
      comparisonPeriod,
      productGroup,
      periodType,
      appliedFilters: [],
    };
    await addCountryLoadedTagInPlace(baseTags, baseApiParams, collectionDataType);
  } else {
    await addPgLoadedTagInPlace(baseTags, insight.apiParams, collectionDataType);
  }

  const otherTags = [
    {
      key: 'KPI',
      value: capitalizeEachWord(
        typeof selectedKpiOption.label === 'object' && selectedKpiOption.label !== null
          ? JSON.stringify(selectedKpiOption.label)
          : String(selectedKpiOption.label),
      ),
    },
  ];

  if (showPerformance) {
    otherTags.push({
      key: 'Show',
      value: capitalizeFirstLetter(showPerformance),
    });
  }

  return [...baseTags, ...otherTags];
};
